import { FC, useEffect } from "react";
import { useMutation } from "react-query";
import { Button, CircularProgress, Paper, TableContainer, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
// import moment from "moment";

import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import { patientWsieReportSearchService, patientWsieReportService } from "./service";
import useRepotFile from "../../hooks/reportFileHook";
import moment from "moment";
import useAuthentication from "@hooks/useAuthentication";



const PatientWiseReport: FC = () => {
  const {user} = useAuthentication()
  const { control,reset,handleSubmit ,getValues} = useForm();
  const {
    mutate: searchList,
    data: searchData,
    isLoading: searchDataDataLoading,
    reset:resetMutation
  } = useMutation(patientWsieReportSearchService);
  const {mutate:getExcel,isLoading:pdfLoading}=useRepotFile({apiFunction:patientWsieReportService,fileType:"xlsx"})
  const onSubmit = (data:any)=>{
    searchList({...data,clinicId:user?.clinicId});
  }

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    resetMutation()
  }

  useEffect(() => {
    searchList({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId:user?.clinicId
    });

     reset({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        })
   }, []);

  const getFiles = () => {
      const allData = getValues();
      getExcel({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
        clinicId:user?.clinicId
      });
    };

    const onChange = ()=>{
        const data = getValues()
        if(data?.fromDate && data?.toDate){
          searchList({ ...data, clinicId:user?.clinicId });
        }else{
          resetMutation()
        }
      }

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
                Patient Wise Report
          </Typography>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-2 gap-3 p-4">
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "to Date" }}
            rules={{ required: "to Date is required",onChange}}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
         <Button
                     disabled={pdfLoading ||searchDataDataLoading|| !Boolean(searchData?.response?.length)}
                     endIcon={pdfLoading && <CircularProgress size={18} />}
                     data-filetype="pdf"
                     onClick={getFiles}
                   >
                     Download Excel
                   </Button>
        </div>
        <TableComponent
          loading={searchDataDataLoading}
          data={searchData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default PatientWiseReport;
const heading = [
  { heading: "Patient Name", key: "patientName" },
  { heading: "Registered Date", key: "createdDate", date: true },
  { heading: "Net Amount", key: "totalAmount" },
  { heading: "Balance Amount", key: "balanceAmount" },
  { heading: "Insurance Amount", key: "insAmount" },
  { heading: "Patient Share", key: "patShare" },
  { heading: "Total Discount Amount", key: "totalDiscountAmount" },
  { heading: "Total Item Wise Discount", key: "totalItemWiseDiscount" },
  { heading: "Patient Type", key: "patientType" },
  { heading: "Insurance Type Name", key: "insurancetypeName" },
  { heading: "Insurance Name", key: "insuranceName" },
  { heading: "Insurance Group Name", key: "inGroupName" },
  { heading: "Cash Received", key: "cashAmount" },
  { heading: "Wallet Received", key: "walletAmount" },
  { heading: "Card Received", key: "cardAmount" },
  { heading: "Transaction Status", key: "transactionStatus" },
];

